import { render, staticRenderFns } from "./SiteLayout.vue?vue&type=template&id=4f63c08d&scoped=true&"
var script = {}
import style0 from "./SiteLayout.vue?vue&type=style&index=0&id=4f63c08d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f63c08d",
  null
  
)

export default component.exports